import facebookIconSrc from './svg/facebookSocialIcon.svg?url';
import instagramIconSrc from './svg/instagramSocialIcon.svg?url';
import linkedInIconSrc from './svg/linkedInSocialIcon.svg?url';
import youTubeIconSrc from './svg/youtubeSocialIcon.svg?url';

export enum EMlpSocialIconVariant {
	Instagram = 'INSTAGRAM',
	Facebook = 'FACEBOOK',
	LinkedIn = 'LINKEDIN',
	YouTube = 'YOUTUBE',
}

export interface ISocialIcon {
	variant: EMlpSocialIconVariant;
	size?: number;
}

const ICON_MAP: Record<EMlpSocialIconVariant, { src: string; alt: string }> = {
	[EMlpSocialIconVariant.Instagram]: {
		src: instagramIconSrc,
		alt: 'Instagram icon',
	},
	[EMlpSocialIconVariant.Facebook]: {
		src: facebookIconSrc,
		alt: 'Facebook icon',
	},
	[EMlpSocialIconVariant.LinkedIn]: {
		src: linkedInIconSrc,
		alt: 'LinkedIn icon',
	},
	[EMlpSocialIconVariant.YouTube]: {
		src: youTubeIconSrc,
		alt: 'YouTube icon',
	},
};

export function SocialIcon({ variant, size = 40 }: ISocialIcon) {
	const icon = ICON_MAP[variant];

	if (!icon) return null;

	return <img src={icon.src} alt={icon.alt} width={size} height={size} />;
}
